import React from 'react';
import {Link} from 'react-router-dom';
import PageHero from '../components/ui/PageHero';
import {ROUTES} from '../config/company';
export default function NotFound(){return <PageHero eyebrow="404" title="That page isn't on this route." lede="The page you followed is unavailable. Explore trucking services or contact our team." compact><div className="mt-7 flex gap-3"><Link to={ROUTES.home} className="btn-primary">Home</Link><Link to={ROUTES.services} className="btn-outline-light">Trucking services</Link></div></PageHero>}
